import { BaseSyntheticEvent, ClipboardEvent, Dispatch, memo, SetStateAction, useRef } from 'react';
import cn from 'classnames';
import SearchIcon from '@mui/icons-material/Search';

import { SEARCH_REGEX } from 'config';

import s from './styles.module.scss';

interface FiltersSearchProps {
  search: string;
  searchLabel?: string;
  marginLeft?: boolean;
  setSearch: Dispatch<SetStateAction<string>>;
  onSearch: (value: string) => void;
}

const FiltersSearch = ({
  search,
  searchLabel = 'Найти',
  marginLeft,
  setSearch,
  onSearch,
}: FiltersSearchProps) => {
  const searchRef = useRef<HTMLInputElement>(null);

  const focusSearch = () => {
    if (!searchRef.current) return;

    searchRef.current.focus();
  };

  const handleSearch = (e: BaseSyntheticEvent) => {
    const { value, selectionStart } = e.target;

    if (!SEARCH_REGEX.test(value)) {
      setSearch(value);
      onSearch(value);

      return;
    }

    const newValue = value.replace(SEARCH_REGEX, '');

    e.target.value = newValue;

    const newSelection = selectionStart - 1;

    e.target.setSelectionRange(newSelection, newSelection);
  };

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    const paste = e.clipboardData.getData('text');

    const newPaste = paste.replaceAll(SEARCH_REGEX, '');

    const target = e.target as HTMLInputElement;
    const cursorStart = target.selectionStart || 0;
    const cursorEnd = target.selectionEnd || 0;
    const searchStart = search.slice(0, cursorStart);
    const searchEnd = search.slice(cursorEnd, search.length);

    const newValue = `${searchStart}${newPaste}${searchEnd}`;

    setSearch(newValue);
    onSearch(newValue);

    setTimeout(() => {
      const newCursorPosition = cursorStart + newPaste.length;

      target.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  };

  return (
    <div className={cn(s.search, { [s.marginLeft]: marginLeft })}>
      <input
        ref={searchRef}
        value={search}
        placeholder={searchLabel}
        onInput={handleSearch}
        onPaste={handlePaste}
      />
      <button aria-label="Поиск" onClick={focusSearch}>
        <SearchIcon sx={{ fill: '#0000008f' }} />
      </button>
    </div>
  );
};

export const FiltersSearchMemo = memo(FiltersSearch);
